import { render, staticRenderFns } from "./stage_component.vue?vue&type=template&id=5605bc33"
import script from "./stage_component.vue?vue&type=script&lang=js"
export * from "./stage_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports